import { ActionEventAction, ElementEventAction, EventTrigger, EventTriggerFixed, Main } from 'services/Analytics/core';
import type { EventDataOverrides } from 'services/Analytics/core/Interfaces/Events';

import { changePathNameToScreenId, getEventSchemaKey } from '../helpers';

interface TrackClickData {
    elementEvent?: ElementEventAction;
    actionEvent?: ActionEventAction;
    screenIdParam?: string;
    eventLabel?: string | object;
    isEventSchemaKey?: boolean;
    // Optional event data overrides (e.g. ab_test_name) - merged into the analytics payload */
    eventDataOverrides?: EventDataOverrides;
}

export const trackScreenLoad = (screenIdParam?: string, eventLabel?: string | string[] | { [key: string]: any }) => {
    const screenId = screenIdParam || changePathNameToScreenId();

    Main.trackNew({
        eventData: { event: EventTrigger.screenLoad, screenId },
        actionData: {
            elementEvent: ElementEventAction.screen,
            actionEvent: ActionEventAction.load,
        },
        ...(eventLabel && { data: { event_label: eventLabel } }),
    });
};

export const trackEventFixed = ({
    event,
    eventLabel,
    isEventSchemaKey,
}: {
    event: EventTriggerFixed;
    eventLabel?: string | string[] | Record<string, string> | object;
    isEventSchemaKey?: boolean;
}) => {
    Main.trackNew({
        eventData: event,
        data: {
            ...(eventLabel && { event_label: eventLabel }),
            ...(isEventSchemaKey && { event_schema_key: getEventSchemaKey(event) }),
        },
    });
};

export const trackClick = ({
    elementEvent,
    actionEvent,
    screenIdParam,
    eventLabel,
    isEventSchemaKey,
    eventDataOverrides,
}: TrackClickData) => {
    const screenId = screenIdParam ? screenIdParam : changePathNameToScreenId();

    Main.trackNew({
        eventData: { event: EventTrigger.click, screenId },
        ...(elementEvent && actionEvent && { actionData: { elementEvent, actionEvent } }),
        data: {
            ...(eventLabel && { event_label: eventLabel }),
            ...(isEventSchemaKey && { event_schema_key: getEventSchemaKey({ event: EventTrigger.click, screenId }) }),
            ...eventDataOverrides,
        },
    });
};

export const trackCustomEvent = ({
    eventData,
    actionData,
    eventLabel,
}: {
    eventData: string;
    actionData: string;
    eventLabel: string | object;
}) => {
    Main.trackNew({
        eventData,
        ...(actionData && { actionData }),
        ...(eventLabel && { data: { event_label: eventLabel } }),
    });
};
